import React from 'react';
import { useIntl } from 'react-intl';
import useNavigation from 'enhancers/use-navigation';
import Html from 'components/html';
import Link from 'components/link';
import Button from 'components/button';
import { noopFn } from 'utils/noop';

import Email from '../../shared/email/email';
import AgreementCheckbox from '../../shared/agreement-checkbox/agreement-checkbox';
import Password from '../../shared/password/password';
import registrationStyles from '../../registration.module.scss';
import { EmailAvailabilityStatus } from '../../../registration.service';

import { testId } from './create-account.settings';
import styles from './create-account.module.scss';
import messages from './create-account.i18n';

const CreateAccount: React.FunctionComponent<unknown> = () => {
  const { formatMessage } = useIntl();
  const [, , link] = useNavigation();

  return (
    <React.Fragment>
      <Html.h2 typography="title1" fontWeight="bold" className={['text-center', 'mb-8']}>
        {formatMessage(messages.pages.signup.registration.steps.createAccount.headerTitle)}
      </Html.h2>
      <Html.div className={styles.createAccount}>
        <Html.div className="mb-8">
          <Email
            initialValue=""
            onChange={noopFn}
            availability={{ status: EmailAvailabilityStatus.Available, email: '' }}
            error={undefined}
            rejectionReason={undefined}
            loading={false}
            disabled
            skeleton
            variant="outline"
            spaceless
          />
        </Html.div>
        <Html.div className="mb-8">
          <Password onChange={noopFn} error={undefined} disabled skeleton variant="outline" spaceless />
        </Html.div>
        <AgreementCheckbox
          initialValue={false}
          onChange={noopFn}
          error={undefined}
          rejectionReason={undefined}
          disabled
          variant="outline"
        />
        <Html.div className="mt-8 text-center">
          <Button
            type="submit"
            testId={testId.next}
            className={['w-100', 'w-sm-auto', 'text-center', registrationStyles.nextButton]}
            disabled
          >
            {formatMessage(messages.pages.signup.registration.steps.createAccount.button)}
          </Button>
        </Html.div>
        <Html.div className={[styles.login, 'mt-6 text-center']} typography="body1">
          {formatMessage(messages.pages.signup.registration.steps.createAccount.login, {
            a: (text: React.ReactNode) => (
              <Link href={link.login()} target="_blank" variant="primary">
                {text}
              </Link>
            ),
          })}
        </Html.div>
      </Html.div>
    </React.Fragment>
  );
};

export default React.memo(CreateAccount);
